import { DateTime } from 'luxon';
import { ObjectState } from '../../enums/objectState.enum';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';
import { Guid } from '../guid';

export class WhitelistIpConfig implements IConfigObjectBase {
	id = Guid();
	name = '';
	description?: string;
	dateCreated = DateTime.now();
	lastUpdated = DateTime.now();
	objectState?: ObjectState;
	block = false;

	value = '';
	userID?: string;

	constructor(init?: Partial<WhitelistIpConfig>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
